// extracted by css-extract-rspack-plugin
export default {"action":"action-BRX2wt"};